

import { useWebSocket } from 'context/WebSocketContext';
import { TablePaginationActions } from 'examples/Tables/CustomPaginationTable';
import DataTable from 'examples/Tables/DataTable';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import crudsService from 'services/cruds-service';

function LogsTable(props) {

    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false)
    const [selectedLogs, setSelectedLogs] = useState([])
    const [search, setSearch] = useState(undefined);
    const { assetTrackerData, holyKelData, levelMonitorData } = useWebSocket();

    async function fetchMonitoLogs(page, size, searchVal = undefined) {
        try {
            setLoader(true)
            let resp = await crudsService.getDeviceMonitorLogs(props.id, page, size, searchVal)

            if (resp.success) {
                let params = props.getRows(resp.data)
                setData(params)
                const { total } = resp.pagination;
                setTotal(total)
            }

        } catch (error) {
            console.error('fetchMonitorLogs', error)
        } finally {
            setLoader(false)
        }
    }

    async function onPageChange(e, page) {
        e.stopPropagation();
        setPage(page)
    }

    async function onRowsPerPageChange(e, value) {
        e.stopPropagation();
        setPageSize(value)
    }

    const removeLogs = async (e) => {
        try {
            if (!confirm('Are you sure you want to delete this logs?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                setLoader(true)
                await crudsService.removeMonitorDeviceParameterValue({ device_id: props.id, logs_id: selectedLogs });
                toast.success('The Device Logs has been successfully deleted')
                setSelectedLogs([])
                await fetchMonitoLogs(page, pageSize)
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('error')) {
                toast.error(err.error)
            }
        } finally {
            setLoader(false)
        }
    }

    function latestData(data){
        const info = [{
            created_at: new Date(),
            data,
            id: '-'
        }]
        let params = props.getRows(info)
        setData((prev) => [params[0], ...prev])
    }

    useEffect(() => {
        if (page > 0) {
            fetchMonitoLogs(page, pageSize, search)
        }
    }, [page, pageSize])

    useEffect(() => {
        if (assetTrackerData && assetTrackerData.device_id == props.id) {
            latestData(assetTrackerData.data)
        }
    }, [assetTrackerData]);

    useEffect(() => {
        if (holyKelData && holyKelData.device_id == props.id) {
            if(holyKelData?.type && holyKelData?.type == 'duplicate'){
                return
            }
            let { channels } = holyKelData.data;
            if(channels && Object.keys(channels).length > 0){
                latestData(holyKelData.data)
            }
        }
    }, [holyKelData]);

    useEffect(() => {
        if (levelMonitorData && levelMonitorData.device_id == props.id) {
            latestData(levelMonitorData.data)
        }
    }, [levelMonitorData]);

    function onSearchChange(value) {
        setSearch(value)
        if(value && typeof value == 'string') {
            fetchMonitoLogs(1, pageSize, value)
        } else {
            if(page == 1){
                fetchMonitoLogs(1, pageSize)
            } else {
                setPage(1)
            }
        }
    }


    return (
        <>
            <DataTable
                table={{
                    columns: props.columns,
                    rows: data
                }}
                loader={loader}
                entriesPerPage={{ defaultValue: pageSize }}
                canPagination={false}
                selectedRows={selectedLogs}
                setSelectedRows={setSelectedLogs}
                deleteFunc={(e) => removeLogs(e)}
                customSearch={true}
                onCustomSearchChange={(val) => onSearchChange(val)}
                {...props}
            />
            {
                total > pageSize &&
                <TablePaginationActions count={total} page={page} rowsPerPage={pageSize} onPageChange={onPageChange} onRowsPerPageChange={onRowsPerPageChange} />
            }
        </>
    )
}

export default LogsTable